/**
 * Resolves the observability API base URL from Vite env.
 * Extracted so tests can mock this module without touching import.meta.
 */

export function getApiBaseUrl(): string {
  const url = import.meta.env.VITE_API_URL;
  if (url === undefined || url === '') {
    throw new Error('VITE_API_URL is not configured');
  }
  return url.replace(/\/$/, '');
}
